import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "common/css/master.css";
import "../css/transport.css";
import Header from "common/js/header/header.js";
import RouteStopListTable from "./routeStopListTable.js";
import RouteStopSlider from "./routeStopSlider";
import LatLngSlider from "./latLngSlider";
import { deleteRouteStopSvc } from "./routeSvc";
import { useLocation } from "react-router-dom";
import StudentStopAllocationSlider from './StudentStopAllocationSlider'

function RouteStopListCtrl() {
  const [loader, setLoader] = useState("none");
  const [flgSlider, setFlgSlider] = useState(false);
  const [randNo, setRandNo] = useState(0);
  const [stopObj, setStopObj] = useState({})
  const [stopNo, setStopNo] = useState({});
  const [stopId, setStopId] = useState(0);
  const [stopDesc, setStopDesc] = useState('')
  const search = useLocation().search;
  const [routeId, setRouteId] = useState(
    new URLSearchParams(search).get("routeId")
  );
  const [routeNo, setRouteNo] = useState(
    new URLSearchParams(search).get("routeNo")
  );
  const [flgMorEve, setFlgMorEve] = useState(false);
  const [sliderKey, setSliderKey] = useState(0)
  const [flgSliderStudentAllocation, setFlgSliderStudentAllocation] = useState(false)

  useEffect(() => {
    // console.log(routeNo + "::" + routeId);
  }, []);

  function generateRandomNo() {
    var lRandNo = Math.floor(Math.random() * 999999);
    // console.log(lRandNo);
    setRandNo(lRandNo);
  }
  function generateSliderKey() {
    var lRandNo = Math.floor(Math.random() * 999999);
    // console.log(lRandNo);
    setSliderKey(lRandNo);
  }

  function openStudentAllocationSlider() {
    setFlgSliderStudentAllocation(true);
  }
  function closeSlider() {
    setFlgSlider(false);
    setFlgSliderStudentAllocation(false);
    setStopId(0);
    setStopNo(0)
    setStopDesc('')
    generateRandomNo();
  }
  const getWingId = (wingId) => {
    // console.log("wingId" + wingId);
  };
  return (
    <div
      className="MainContainer"
      style={{ pointerEvents: loader === "none" ? "auto" : "none" }}
    >
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: "50%",
          top: "50%",
          display: loader,
        }}
      >
        <img
          className="loderImg"
          src={require("common/images/loader.gif")}
          alt="Loader..."
        />
      </div>
      <Header wingFromChild={getWingId} />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div className="TestTblWrapper" style={{ marginTop: 0, marginBottom: 0 }}>
        <div className="col-sm-12 padding-remove"></div>
        <div className="col-sm-12 padding-remove"></div>
        <div className="TestTbl">
          <RouteStopListTable
            setStopObj={setStopObj}
            setStopId={setStopId}
            routeId={routeId}
            key={stopId}
            routeNo={routeNo}
            closeSlider={closeSlider}
            generateRandomNo={generateRandomNo}
            generateSliderKey={generateSliderKey}
            openStudentAllocationSlider={openStudentAllocationSlider}
          />
        </div>
        {flgSliderStudentAllocation && stopId && <div
          className="TestSlider"
          style={{
            display: flgSliderStudentAllocation ? "block" : "none",
            width: "90%",
            overflowY: "none",
          }}
        >
          <StudentStopAllocationSlider
            key={randNo}
            openSlider={openStudentAllocationSlider}
            closeSlider={closeSlider}
            setRandNo={setRandNo}
            setStopId={setStopId}
            flgSliderLatLng={flgSliderStudentAllocation}
            generateRandomNo={generateRandomNo}
            stopObj={stopObj}
            stopId={stopId}
            routeId={routeId}
            routeNo={routeNo}
          />
        </div>}

      </div>
    </div>
  );
}
export default RouteStopListCtrl;
